import React, { useState,  useEffect } from 'react';
import './i18n';  //// import i18n (needs to be bundled ;)) 
import { useTranslation } from 'react-i18next';
import { use } from 'i18next';
import { useAppCtx } from './app-ctx';
import { utf8_to_b64, b64_to_utf8 } from './utils/util';

import Tabbed from './tabbed';

const IndexPage = () => {
    const { t, i18n } = useTranslation();
    const {JOOMLA_VARS, CONFIG} = useAppCtx();
    const [searchHints, setSearchHints] = useState([]);

    const s = {
        keywords: null,
        rooms: [
                { adults: 2, 
                  children: 1, 
                  mealsAdult: 1, 
                  mealsChildren: 1
                }
        ],
    };

    console.log('IndexPage():JOOMLA_VARS='+ JSON.stringify(JOOMLA_VARS));

    //the structure searchCriterias is defined below into SearchForm
    const [searchCriterias, setSearchCriterias] = useState(s);

    //handleLookup()
    //this is called when user clicks "Search" button in SearchForm
    //See:
    //  SearchForm::handleSubmit()
    const handleLookup = (searchCriterias) => {
        console.log('IndexPage.handleLookup():searchCriterias'+ JSON.stringify(searchCriterias));

        const storageKey = CONFIG.localStorageKeyForSearchCriterias;
        localStorage.setItem(storageKey, JSON.stringify(searchCriterias));

        // post searchCriterias to /resorts page to let back-end  chance to do its job and reload the page
        const form = document.createElement("form");
        form.method = "POST";
        form.action = JOOMLA_VARS.resortListUrl;
        //form.target = "_blank"; // Open in a new tab

        const input = document.createElement("input");
        input.type = "hidden";
        input.name = "searchCriterias";
        var valueB64 = utf8_to_b64( JSON.stringify(searchCriterias) );
        input.value = valueB64;

        console.log('IndexPage:handleLookup():input.value:'+ input.value);

        form.appendChild(input);
        document.body.appendChild(form);
        form.submit();

        document.body.removeChild(form); // Clean up
    }


    console.log("IndexPage(): today:" + (new Date()).toString());
    console.log('IndexPage():searchCriterias'+ JSON.stringify(searchCriterias));

    //IndexPage
    //  <Tabbed>
    //      <Tabs>
    //          <TabPanel>
    //              <SearchForm>
    //                  <CriteriaKeywords />
    //                  <CriteriaRoomsPeople />
    //                  <CriteriaDietaryTreatment />
    //                  <CriteriaDateRange />

    return (
        <Tabbed searchCriterias={searchCriterias} 
                diseasesHints={searchHints}
                onLookup={handleLookup}
                onSearchCriteriasChange={ (searchCriterias) => {
                    console.log('IndexPage:onSearchCriteriasChange():searchCriterias'+ JSON.stringify(searchCriterias));
                    setSearchCriterias(searchCriterias);
                }} />
    );
};

export default IndexPage;
